/**
 *
 * Smooth scroll to anchor element
 *
 * Usage example:
 *
 * <a href="#anchor-to-scroll-to" class="smooth-scroll">
 * <a id="anchor-to-scroll-to"></a> OR <a name="anchor-to-scroll-to"></a>
 *
 */

const smoothScroll = {
  init: function() {
    const self = this,
      smoothScrollLinks = document.getElementsByClassName('smooth-scroll');

    if (smoothScrollLinks.length) {
      for (const link of smoothScrollLinks) {
        link.addEventListener('click', function(event) {
          event.preventDefault();

          const hrefValue = event.target.getAttribute('href').substring(1),
            targetAnchor = document.getElementById(hrefValue) || document.querySelector('a[name="' + hrefValue + '"]');

          if (targetAnchor) self.scrollTo(document.documentElement, targetAnchor.offsetTop, 500);
        });
      }
    }
  },

  scrollTo: function(element, to, duration) {
    if (duration <= 0) return;

    const difference = to - element.scrollTop,
      perTick = difference / duration * 10;

    setTimeout(function() {
      element.scrollTop = element.scrollTop + perTick;

      if (element.scrollTop === to) return;

      smoothScroll.scrollTo(element, to, duration - 10);
    }, 10);
  }
};

export default smoothScroll;
